<div class="card">
  <div class="card-body pl-0 pr-0 pb-0">
    <div class="pl-0 pr-0 pb-0 actions-container">
      <div class="row p-3">
        <div class="col-md-6 col-lg-6 col-xl-6 col-sm-12">
          <div class="input-group">
            <input class="form-control border-right-0"
            #filter
            type="text"
            placeholder="BUSCAR"
            [(ngModel)]="searchString">
            <span class="input-group-append bg-white border-left-0">
            <span class="input-group-text bg-transparent">
              <i class="bi bi-search"></i>
            </span>
        </span>
          </div>
        </div>

      </div>
    </div>
    <div class="table-responsive">
      <table class="table table acierto-table-color">
        <thead>
        <tr class="text-white d-flex default-font-size">
          <th class="col-2 text-center">USUARIO</th>
          <th class="col-1 text-center">CÓDIGO</th>
          <th class="col-2 text-center">NOMBRE COMPLETO</th>
          <th class="col-1 text-center">ROL</th>
          <th class="col-1 text-center">PUESTO</th>
          <th class="col-1 text-center">EMAIL</th>
          <th class="col-1 text-center">UNIDAD</th>
          <th class="col-1 text-center">DIRECCIÓN</th>
          <th class="col-1 text-center">EDITAR</th>
          <th class="col-1 text-center">ACTIVAR / DESACTIVAR</th>
        </tr>
        </thead>
        <tbody class="default-table-body-color default-font-size">
        <tr class="d-flex"
          *ngFor="
          let user of data |
          filter: searchString |
          paginate: {
            itemsPerPage: itemsPerPage,
            currentPage: p
          }">
          <td class="col-2 text-center">{{ user.usuario.toUpperCase() }}</td>
          <td class="col-1 text-center">{{ user.codigo_antiguedad }}</td>
          <td class="col-2 text-center">{{ user.nombre_completo.toUpperCase() }}</td>
          <td class="col-1 text-center">{{ user.nombre_rol.toUpperCase() }}</td>
          <td class="col-1 text-center">{{ user.puesto|ReplaceText: 'N/D' }}</td>
          <td class="col-1 text-center">{{ user.correo|ReplaceText: 'N/D' }}</td>
          <td class="col-1 text-center">{{ user.unidad_administrativa|ReplaceText: 'N/D' }}</td>
          <td class="col-1 text-center">{{ user.direccion|ReplaceText: 'N/D' }}</td>
          <td class="col-1 text-center">
            <i class="bi bi-pencil-square action-icon"
               *ngxPermissionsOnly="['editarPerfil']"
               [routerLink]="['/modulo-seguridad/', 'seguridad', 'creacion-perfil']"
               (click)="changeMenuModule('creacion-perfil'); editProfile(user)"></i>
          </td>
          <td class="col-1 text-center">
            <input
              type="checkbox"
              id="chk2"
              [checked]="user.estado_usuario"
              (change)="user.activo = $event.target.checked; changeUserStatus(user)">
          </td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="col-md-12 ml-0 mr-0 p-0 mt-4 text-center">
      <pagination-controls
        class="p-0 my-pagination"
        previousLabel="Anterior"
        nextLabel="Siguiente"
        maxSize="6"
        (pageChange)="p = $event"
        (pageBoundsCorrection)="p = $event"
      ></pagination-controls>
    </div>
  </div>
</div>
